(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        
        var TrackingScriptName = 'googleAnalytics4';        
        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("googleAnalytics4", TrackingModel);
        if (!Tracker) return;
        var selectItemEventEnabled = Tracker.Properties.SelectItemEventEnabled && Tracker.Properties.SelectItemEventEnabled == 'true';

        Init();

        function Init() {

            window.dataLayer = window.dataLayer || [];

            var trackedLists = []; // Save tracked lists
            var viewedItems = []; // Save viewed items in lists

            //TRACK user id
            var loginEventFromStorage = localStorage.getItem('login_event'); // Get event stored from login success message
            var currentUserModelFromStorage = localStorage.getItem('CurrentUserModel'); // Current user model to get user id

            if (currentUserModelFromStorage !== null) {
                var currentUserModel = JSON.parse(currentUserModelFromStorage);
                var userIdentifier = currentUserModel.UserIdentifier;

                if (loginEventFromStorage !== null) { //TRACK login and user id - Push "login" event
                    localStorage.removeItem("login_event");
                    var loginEvent = JSON.parse(loginEventFromStorage);

                    dataLayer.push({ 'method': null });
                    dataLayer.push({
                        'event': 'login', 
                        'method': loginEvent.method, // Login method
                        'userId': userIdentifier
                    });
                } else if (userIdentifier !== null){
                    dataLayer.push({ //TRACK user id, for use on all events bellow
                        'userId': userIdentifier
                    });
                }

                dataLayer.push({
                    'event': 'vendd_user_set' // This event fires general configuration tag in GTM
                });
            }
            
            //TRACK product list - Push "view_item_list" Event
            if ((TrackingModel.IsHomePage || TrackingModel.IsProductListPage || TrackingModel.IsProductDetailsPage || TrackingModel.IsBrandPage || TrackingModel.IsCartPage || TrackingModel.IsAllOtherPages) && TrackingModel.ProductListsData) {

                function checkViewableLists() { // Function to check if a list is in viewport

                    TrackingModel = LhApp.Function.Tracking.getTrackingModel(); // Updated Tracking Model to include lazy product lists

                    Object.entries(TrackingModel.ProductListsData).forEach(function (list) { // Iterate through product lists

                        var listName = list[0]; // List Name

                        if (trackedLists.indexOf(listName) >= 0) return; // This list is already tracked

                        var $thisEl = $('[data-list-title="' + listName + '"]');
                        
                        if ($thisEl.is(':visible') && isElementPartialyInViewport($thisEl, { height: 100, width: 100 })) { // Check if this list is in view port
                            trackList(list);
                            trackedLists.push(listName);
                            if (selectItemEventEnabled) {
                                bindSelectItemEvent($thisEl, listName); // Helper to select item event
                            }
                        }
                         
                    });

                }

                function trackList(list) { // Function to send list data to the dataLayer

                    var items = []; // Push Each Item (product) from the model to the array
                    var listKey = list[0]; // List Name
                    var listValues = list[1]; // List Content  

                    listValues.forEach(function (product) {

                        var itemDataFormatted = {
                            item_id: product.ProductId,
                            item_name: product.Name,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: product.Position,
                            item_brand: product.Brand,
                            item_category: product.Category,
                            item_list_id: listKey,
                            item_list_name: listKey,
                            item_variant: product.Color,
                            price: product.PriceWithoutVatN,
                            quantity: 1
                        }

                        items.push(itemDataFormatted);
                        if (selectItemEventEnabled) {
                            viewedItems.push(itemDataFormatted);
                        }
                    });

                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'view_item_list', // Event Name to identify in Tag Manager
                        'ecommerce': {
                            'item_list_id': listKey,
                            'item_list_name': listKey,
                            'items': items // ProductListsData (Model) to DataLayer
                        }
                    })
                }

                checkViewableLists(); // Runs on page load

                $(window).scroll($.debounce(300, checkViewableLists)); // Runs when user scrolls

            }

            //TRACK select item from list - Push "select_item" Event
            function bindSelectItemEvent($list, listName) {
                $('a', $list).on('click', function (evt) {
                                        
                    var redirectLink = $(this).prop('href');
                    if (!redirectLink) return console.warn('GA4 select_item event: redirectLink not found');

                    evt.preventDefault();
                    evt.stopImmediatePropagation();

                    var productId = $(this).closest('[data-productid]').attr('data-productid');
                    var productObject = viewedItems.filter(function (i) { return i.item_id == productId })[0];

                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'select_item', // Event Name to identify in Tag Manager
                        'ecommerce': {
                            'item_list_id': listName,
                            'item_list_name': listName,
                            'items': [productObject] // ProductData (Model) to DataLayer
                        },
                        'eventCallback': function () {
                            window.location = redirectLink;
                        }
                    })

                    setTimeout(function () { // Redirect in any case after 500ms
                        window.location = redirectLink;
                    }, 500);

                })
            }

            //TRACK product details - Push "view_item" Event
            if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData) {

                var list = []; // List to send to dataLayer

                if (TrackingModel.ProductData.length > 0) { // Check if it is simple product or Get the look list
                    list = TrackingModel.ProductData;
                } else if (TrackingModel.ProductListsData.getthelooklist && TrackingModel.ProductListsData.getthelooklist.length > 0) {
                    list = TrackingModel.ProductListsData.getthelooklist;
                }

                var items = []; // Push each item from the model to the array
                var totalPrice = 0; // Value to add total price of all items

                list.forEach(function (product, index) {

                    var itemDataFormatted = {
                        item_id: product.ProductId,
                        item_name: product.Name,
                        affiliation: "Online Store",
                        currency: LhApp.Context.Currency.Code, 
                        index: index,
                        item_brand: product.Brand,
                        item_category: product.Category,
                        price: product.PriceWithoutVatN,
                        quantity: 1
                    }

                    totalPrice += parseFloat(product.PriceWithoutVatN);

                    items.push(itemDataFormatted);
                });

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'view_item', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': totalPrice,
                        'items': items // ProductData (Model) to DataLayer
                    }
                })
                 
            }

            //TRACK checkout Angular(ready) - Push "begin_checkout" Event
            if (TrackingModel.IsCheckoutPage) {
                var ready = false;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        //register events once
                        if (!ready) {
                            ready = true;

                            var smScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

                            if (!smScope) return;

                            var items = []; // Push Each Item from the model to the array

                            smScope.Model.Data.Products.forEach(function (product, index) {

                                product.FirstDimension = (product.Dimensions[0] && product.Dimensions[0].Name) ? product.Dimensions[0].Name : '';
                                product.PriceWithoutVatN = parseFloat(product.PriceWithoutVatText.replace(',', '.'));

                                var itemDataFormatted = {
                                    item_id: product.ProductId,
                                    item_name: product.Title,
                                    affiliation: "Online Store",
                                    currency: LhApp.Context.Currency.Code,
                                    index: index,
                                    item_brand: product.ManufacturerName,
                                    item_category: product.CategoryName,
                                    item_variant: product.FirstDimension,
                                    price: product.PriceWithoutVatN,
                                    quantity: product.Quantity
                                }

                                items.push(itemDataFormatted);
                            });

                            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                'event': 'begin_checkout', // Event Name to identify in Tag Manager
                                'ecommerce': {
                                    'currency': LhApp.Context.Currency.Code,
                                    'value': smScope.Model.Data.TotalCost,
                                    'coupon': "",
                                    'items': items // CartProductsData (Model) to DataLayer
                                }
                            })

                        }
                    });
                }
            }

            //TRACK order completion - Push "purchase" Event
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                //get transaction cookie
                var transactionCookie = Cookies.get('transaction_id');

                //check if transaction cookie already exists
                if (typeof transactionCookie === 'undefined' || (typeof transactionCookie !== 'undefined' && parseInt(transactionCookie) !== TrackingModel.Order.Id)) {
                    var items = []; // Push Each Item from the model to the array

                    TrackingModel.CartProductsData.forEach(function (product, index) {

                        var itemDataFormatted = {
                            item_id: product.ProductId,
                            item_name: product.Name,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: index,
                            item_brand: product.Brand,
                            item_category: product.Category,
                            item_list_id: product.List,
                            item_list_name: product.List,
                            item_variant: product.Color,
                            price: product.PriceWithoutVatN,
                            quantity: product.Quantity
                        }

                        items.push(itemDataFormatted);
                    });

                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'purchase', // Event Name to identify in Tag Manager
                        'ecommerce': {
                            'transaction_id': TrackingModel.Order.Id,
                            'affiliation': TrackingModel.Order.StoreName,
                            'value': TrackingModel.Order.ProductsCostWithouVatN,
                            'tax': TrackingModel.Order.VatCostN,
                            'shipping': TrackingModel.Order.ShippingCostWithoutVatN,
                            'currency': LhApp.Context.Currency.Code,
                            'coupon': "",
                            'items': items // CartProductsData (Model) to DataLayer
                        }
                    })

                    //set current transaction cookie
                    Cookies.set("transaction_id", TrackingModel.Order.Id, { samesite: 'Lax' });
                }  
            }

            //TRACK share - Push "share" Event from addthis
            if (typeof addthis !== 'undefined') {
                function addThisEventHandler(evt) {
                    if (evt.type == "addthis.menu.share") {

                        var item_id = (LhApp.Context.Item.Id) || '';

                        dataLayer.push({ 'method': null, 'content_type': null, 'item_id': null, 'url': null }); // Clear the previous object.
                        dataLayer.push({
                            'event': 'share', // Event Name to identify in Tag Manager
                            'method': evt.data.service, // Share Network
                            'content_type': inlineAdminGlobalVariables.EntityCode, // Content to share
                            'item_id': item_id, // Content Item id
                            'url': window.location.href // Content Url
                        });

                    }
                }
                addthis.addEventListener('addthis.menu.share', addThisEventHandler);
            }

            //TRACK share - Push "share" Event from html anchor clicks
            if ($('.x-share-buttons .initialized').length > 0) {
                $('.x-share-buttons .initialized').on("click", "li a", function () {

                    var item_id = (LhApp.Context.Item.Id) || '';

                    dataLayer.push({ 'method': null, 'content_type': null, 'item_id': null, 'url': null }); // Clear the previous object.
                    dataLayer.push({
                        'event': 'share', // Event Name to identify in Tag Manager
                        'method': $(this).text(), // Share Network
                        'content_type': inlineAdminGlobalVariables.EntityCode, // Content to share
                        'item_id': item_id, // Content Item id
                        'url': window.location.href // Content Url
                    });

                });
            }

            //TRACK promotion - Push "view_promotion" Event
            if ($('[data-view_promotion="true"]').length > 0) {

                function checkViewablePromos() {

                    $('[data-view_promotion="true"]').each(function () {
                        
                        if ($(this).is(':visible') && isElementPartialyInViewport($(this), { height: 100, width: 100 })) { // Check if this promotion is in view port

                            if (trackedPromo.indexOf($(this).attr('data-creative_slot')) >= 0) return; // This promo is already tracked

                            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                'event': 'view_promotion', // Event Name to identify in Tag Manager
                                'ecommerce': {
                                    creative_slot: $(this).attr('data-creative_slot'),
                                    creative_name: $(this).attr('data-creative_name'),
                                    items: [{
                                        item_id: $(this).attr('data-item-id')
                                    }]
                                }
                            })

                            trackedPromo.push($(this).attr('data-creative_slot'));
                        }

                    });

                }

                var trackedPromo = []; // Save tracked promotions

                checkViewablePromos(); // Runs on page load

                $(window).scroll($.debounce(300, checkViewablePromos)); // Runs when user scrolls
            }

            //TRACK select promotion - Push "select_promotion" Event
            $('[data-view_promotion="true"]').click('a', function (evt) {

                var redirectLink = $(this).find('a').prop('href');
                var itemID = $(this).attr('data-item-id');
                
                if (!redirectLink) return console.warn('GA4 select_promotion event: redirectLink not found'); 
                if (!itemID) return console.warn('GA4 select_promotion event: itemID not found');

                evt.preventDefault(); 
                evt.stopImmediatePropagation(); // Prevent redirect from child a element

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'select_promotion', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        creative_slot: $(this).attr('data-creative_slot'),
                        creative_name: $(this).attr('data-creative_name'),
                        items: [{
                            item_id: $(this).attr('data-item-id')
                        }]
                    },
                    'eventCallback': function () {
                        window.location = redirectLink;
                    }
                })

                setTimeout(function () { // Redirect in any case after 500ms
                    window.location = redirectLink;
                }, 500);

            })
        }

        // IMPORTANT execute these scripts in all other pages except checkout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            var _cartAddResponses = []; // Used for add to cart
            var _wishAddResponses = []; // Used for add to wishlist
            var cartModel; // Saves current cartModel state
            var wishModel; // Saves current wishModel state
            var currentColor; // Used to check view item event if user views different color
            var dontTrackNextViewCart = false; // Used to prevent firing view cart event after item removal
            var idsToRemove = []; // Used for multiple items removal
            var loginTracked = false; // Prevent double fire of login event

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                Init();
            });

            //TRACK Cart Page - Push "view_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName + '_view_cart_page', function (envelope) {

                cartModel = envelope.message.data.Cart;

                if (!TrackingModel.IsCartPage || !cartModel) return;

                if (dontTrackNextViewCart) {
                    dontTrackNextViewCart = false;
                    return; // Dont track if item removed from cart
                }

                var items = []; // Push Each Item from the model to the array

                cartModel.Items.forEach(function (product, index) {

                    product.Color = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';                    

                    var itemDataFormatted = {
                        item_id: product.ProductId,
                        item_name: product.Title,
                        affiliation: "Online Store",
                        currency: LhApp.Context.Currency.Code,
                        index: index,
                        item_brand: product.Manufacturer,
                        item_category: product.Category,                        
                        item_variant: product.Color,
                        price: product.Prices.PriceWithoutVatN,
                        quantity: product.Quantity
                    }

                    items.push(itemDataFormatted);
                });

                var totalPriceWithoutVat = parseFloat(cartModel.Summary.TotalWithoutVat.replace(',', '.'));

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'view_cart', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': totalPriceWithoutVat,
                        'items': items // ProductData (Model) to DataLayer
                    }
                })

            });

            //TRACK View Mini Cart Widget - Push "view_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, TrackingScriptName + '_view_mini_cart', function (envelope) {
                
                if (envelope.message.data.widgetName !== "CartWidget") return; // Check if this is CartWidget

                if (dontTrackNextViewCart) {
                    dontTrackNextViewCart = false;
                    return; // Dont track if item removed from cart
                }

                var items = []; // Push Each Item from the model to the array

                cartModel.Items.forEach(function (product, index) { 

                    product.Color = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';
                    
                    var itemDataFormatted = {
                        item_id: product.ProductId,
                        item_name: product.Title,
                        affiliation: "Online Store",
                        currency: LhApp.Context.Currency.Code,
                        index: index,
                        item_brand: product.Manufacturer,
                        item_category: product.Category,                      
                        item_variant: product.Color,
                        price: product.Prices.PriceWithoutVatN,
                        quantity: product.Quantity
                    }

                    items.push(itemDataFormatted);
                });

                var totalPriceWithoutVat = parseFloat(cartModel.Summary.TotalWithoutVat.replace(',', '.'));
     
                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'view_cart', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': totalPriceWithoutVat,
                        'items': items // CartProductsData (Model) to DataLayer
                    }
                })

            });

            //TRACK View Selected Item (When color change) - Push "view_item" Event
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName + '_view_selected_item', function (envelope) {

                var selectedColorId = envelope.message.data.model.SelectedProductColorId;

                if (!TrackingModel.ProductData || !selectedColorId) return;

                if (currentColor == selectedColorId) return; // Do not execute if the same color is selected

                currentColor = selectedColorId; // Reset current color

                var product = TrackingModel.ProductData[0];

                // Find color of this product
                if (product.Colors) { 
                    product.ColorData = product.Colors.filter(function (i) { return i.VersionId == selectedColorId; })[0];
                    product.Color = product.ColorData.Name;
                } else if (!product.Color) {
                    product.Color = '';
                }

                // Structure product data for analytics
                var itemDataFormatted = {
                    item_id: product.ProductId,
                    item_name: product.Name,
                    affiliation: "Online Store",
                    currency: LhApp.Context.Currency.Code,
                    index: 0,
                    item_brand: product.Brand,
                    item_category: product.Category,
                    item_variant: product.Color,
                    price: product.PriceWithoutVatN,
                    quantity: 1
                }
                
                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'view_item', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': product.PriceWithoutVatN, // Total price = Item price
                        'items': [itemDataFormatted] // Put the object in Array[0]
                    }
                })
            });

            //HELPER this script keeps track of products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName + '_add_to_cart', function (envelope) {

                if (!envelope.message.data) return;

                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty)
                });
            });

            //HELPER this script keeps track of multiple products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAdd, TrackingScriptName + '_add_multiple_to_cart', function (envelope) {

                if (!envelope.message.data) return;

                var res = envelope.message.data;

                res.forEach(function (prod) {

                    _cartAddResponses.push({
                        ProductId: prod.id,
                        SkuId: prod.skuId,
                        Quantity: parseFloat(prod.qty)
                    });

                });
                               
            });

            //HELPER this script keeps track of products added to cart from wishlist page
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ProductAdded, TrackingScriptName + '_add_to_cart_from_wishlist', function (envelope) {
   
                if ((LhApp.Context.Item.Template != "wishlist") || !envelope.message.data) return;

                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                });
            });

            //HELPER this script keeps track of "move all to cart" from the wishlist page
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.MoveAllToCart, TrackingScriptName + '_move_all_to_cart_from_wishlist', function (envelope) {

                if ((LhApp.Context.Item.Template != "wishlist") || !envelope.message || (wishModel.Items.length <= 0)) return;
                
                wishModel.Items.forEach(function (Item) {
                    _cartAddResponses.push({
                        ProductId: Item.ProductId,
                        SkuId: Item.VariantId,
                    });
                });

            });

            //TRACK add to cart (recorded by the ABOVE script) - Push "add_to_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName + '_add_to_cart_success', function (envelope) {

                cartModel = envelope.message.data.Cart;

                if (!cartModel || !_cartAddResponses) return;

                var pAddResponse = _cartAddResponses.shift();

                (function AddToCartTrack(p) {
                    if (!p)
                        return;
                                       
                    var product = cartModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    })[0];

                    if (product) {
                        product.Color = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';
                        
                        var itemDataFormatted = {
                            item_id: product.ProductId,
                            item_name: product.Title,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: 0,
                            item_brand: product.Manufacturer,
                            item_category: product.Category,
                            item_variant: product.Color,
                            price: product.Prices.PriceWithoutVatN,
                            quantity: product.Quantity
                        }

                        // Multiply product price by quantity to calc the total value added
                        var value = parseFloat(product.Quantity) * parseFloat(product.Prices.PriceWithoutVatN);

                        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                        dataLayer.push({
                            'event': 'add_to_cart', // Event Name to identify in Tag Manager
                            'ecommerce': {
                                'currency': LhApp.Context.Currency.Code,
                                'value': value,
                                'items': [itemDataFormatted] // Put the object in Array[0]
                            }
                        })

                    }

                    AddToCartTrack(_cartAddResponses.shift());

                })(pAddResponse);
            });

            //HELPER this script keeps track of products added to wishlist 
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Add, TrackingScriptName + '_add_to_wishlist', function (envelope) {

                if (!envelope.message.data) return;

                var res = envelope.message.data;
                _wishAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty)
                });
            });

            //TRACK add to wishlist (recorded by the ABOVE script) - Push "add_to_wishlist" Event
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, TrackingScriptName + '_add_to_wishlist_success', function (envelope) {

                wishModel = envelope.message.data;

                if (!wishModel || !_wishAddResponses) return;

                var pAddResponse = _wishAddResponses.shift();

                (function AddToWishTrack(p) {
                    if (!p)
                        return;

                    var product = wishModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    })[0];

                    if (product) {

                        product.PriceWithoutVat = parseFloat(product.Prices.PriceWithoutVat.replace(',','.'));
                        product.FirstDimension = (product.Dimensions[0] && product.Dimensions[0].Name) ? product.Dimensions[0].Name : '';

                        var itemDataFormatted = {
                            item_id: product.ProductId,
                            item_name: product.Title,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: 0,
                            item_brand: product.Manufacturer,
                            item_category: product.Category,
                            item_variant: product.FirstDimension,
                            price: product.PriceWithoutVat,
                            quantity: 1
                        }
                                               
                        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                        dataLayer.push({
                            'event': 'add_to_wishlist', // Event Name to identify in Tag Manager
                            'ecommerce': {
                                'currency': LhApp.Context.Currency.Code,
                                'value': product.PriceWithoutVat,
                                'items': [itemDataFormatted] // Put the object in Array[0]
                            }
                        })

                    }

                    AddToWishTrack(_wishAddResponses.shift());

                })(pAddResponse);

            });

            //TRACK remove item from cart - Push "remove_from_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Remove, TrackingScriptName + '_remove_from_cart', function (envelope) {

                if (!cartModel || !envelope.message.data) return;

                var product = cartModel.Items.filter(function (i) {
                    return i.Id == envelope.message.data.id;
                })[0];
                                
                if (product) {
                    product.Color = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';
                                        
                    var itemDataFormatted = {
                        item_id: product.ProductId,
                        item_name: product.Title,
                        affiliation: "Online Store",
                        currency: LhApp.Context.Currency.Code,
                        index: 0,
                        item_brand: product.Manufacturer,
                        item_category: product.Category,                        
                        item_variant: product.Color,
                        price: product.Prices.PriceWithoutVatN,
                        quantity: product.Quantity
                    }

                    // Multiply product price by quantity to calc the total value added
                    var value = parseFloat(product.Quantity) * parseFloat(product.Prices.PriceWithoutVatN);

                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'remove_from_cart', // Event Name to identify in Tag Manager
                        'ecommerce': {
                            'currency': LhApp.Context.Currency.Code,
                            'value': value,
                            'items': [itemDataFormatted] // Put the object in Array[0]
                        }
                    })

                    dontTrackNextViewCart = true;
                }
            });

            //HELPER to start multiple items removal from cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemove, TrackingScriptName + '_remove_multiple', function (envelope) {
                if (!envelope.message.data) return;
                idsToRemove = envelope.message.data; // Save ids of items that are getting removed from the cart
            });

            //TRACK remove multiple items from cart - Push "remove_from_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, TrackingScriptName + '_remove_multiple_from_cart', function (envelope) {

                if (!cartModel || !envelope.message.data.success || idsToRemove <= 0) return;

                var items = []; // Init items array to send to the datalayer
                var value = 0; // Init total value of items to send to the datalayer

                idsToRemove.forEach(function (id, index) {

                    var product = cartModel.Items.filter(function (i) {
                        return i.Id == id;
                    })[0];

                    if (product) {
                        product.Color = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';

                        var itemDataFormatted = {
                            item_id: product.ProductId,
                            item_name: product.Title,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: index,
                            item_brand: product.Manufacturer,
                            item_category: product.Category,                            
                            item_variant: product.Color,
                            price: product.Prices.PriceWithoutVatN,
                            quantity: product.Quantity
                        }

                        items.push(itemDataFormatted); // Push this item to array of items that are removed.

                        value += parseFloat(product.Quantity) * parseFloat(product.Prices.PriceWithoutVatN); // Add value to total
                    }
                });
                                
                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'remove_from_cart', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': value,
                        'items': items
                    }
                })

            });

            //TRACK register - Push "sign_up" Event
            Vendd.MessageBus.subscribe(Vendd.User.Messages.RegisterSuccess, TrackingScriptName + '_user_register', function (envelope) {

                if (!envelope.message.data.success) return;

                dataLayer.push({ 'method': null });
                dataLayer.push({
                    'event': 'sign_up', // Event Name to identify in Tag Manager
                    'method': "registration_form" // Sign up method
                });

            });

            //TRACK register - Push "sign_up" Event on b2b registration page
            Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegisterSuccess, TrackingScriptName + '_b2b_user_register', function (envelope) {

                if (!envelope.message.data.success) return;

                dataLayer.push({ 'method': null });
                dataLayer.push({
                    'event': 'sign_up', // Event Name to identify in Tag Manager
                    'method': "b2b_registration_form" // Sign up method
                });

            });

            //HELPER login
            Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, TrackingScriptName + '_user_login', function (envelope) {
                if (!envelope.message.data.success || loginTracked) return;

                var method = '';
                if (LhApp.Context.Item.Template == 'register') {
                    method = "registration_form";
                } else if (LhApp.Context.Item.Template == 'b2bregistrationpage') {
                    method = "b2b_registration_form";
                } else {
                    method = "login_form";
                }
                
                var loginEvent = {
                    'event': 'login', // Event Name to identify in Tag Manager
                    'method': method // Login method
                };

                localStorage.setItem('login_event', JSON.stringify(loginEvent));
                loginTracked = true; // Prevent double fire of login event

            });            
        }
    });
})();
